import styled from "styled-components";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { MainMenuMover } from "../components/MainMenuMover";
import Menu from "../components/menu/Menu";
import { PageTransition } from "../components/PageTransition";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 80px;
  right: 0;
`;

const HeaderLayout = styled.div`
  pointer-events: all;
`;

const MainSection = styled.main`
  position: relative;
  height: 100%;
`;

const Content = styled.div`
  height: 100%;
  pointer-events: all;
`;

const FooterLayout = styled.div`
  position: relative;
  z-index: -1;
  pointer-events: all;
`;

export const LayoutScene: React.FC = ({ children }) => {
  return (
    <Wrapper>
      <PageTransition>
        <HeaderLayout>
          <Header />
        </HeaderLayout>

        <Menu />

        <MainSection>
          <MainMenuMover>
            <Content>{children}</Content>
          </MainMenuMover>
        </MainSection>
        <FooterLayout>
          <Footer isFull={false} />
        </FooterLayout>
      </PageTransition>
    </Wrapper>
  );
};
